import { ILocalizationKeys } from './constant';

const de: ILocalizationKeys = {
	welcome: 'Willkommen',
	youAlreadyHaveAnAccount: 'Du hast bereits ein Konto',
	login: 'Einloggen',
	wouldYouLikeToCreateAnAccount: 'Möchtest du ein Konto erstellen?',
	register: 'Registrieren',
	orSimplyPlayWithoutRegistration: 'oder einfach ohne Anmeldung spielen',
	youCanRegisterAtAnyTimeLater: 'Eine spätere Anmeldung ist jederzeit möglich',
	playInstantly: 'Sofort spielen',
	emailValidation: 'Bitte geben Sie eine gültige E-Mail Adresse an!',
	passwordValidation: 'Bitte geben Sie ein gültiges Passwort ein!',
	email: 'E-Mail',
	password: 'Passwort',
	forgotPassword: 'Passwort vergessen',
	continueWithGoogle: 'weiter mit Google',
	or: 'oder',
	newAccount: 'Neues Konto',
	continueWithEmail: 'weiter mit E-Mail',
	registerWithEmail: 'Mit E-Mail registrieren',
	repeatPassword: 'Passwort Wiederholung',
	pleaseFillOutTheFieldsToRegister: 'Bitte Felder zum Registrieren ausfüllen!',
	passwordNotMatch: 'Passwörter stimmen nicht überein!',
	confirmPassword: 'Zur Bestätigung ist ein Passwort erforderlich!',
	createAnAccount: 'Ein Konto erstellen',
	submit: 'Einreichen',
	deleteAccount: 'Konto löschen',
	crossword: 'Schwedenrätsel',
	gridPuzzle: 'Gitterrätsel',
	sudoku: 'Sudoku',
	wordSearch: 'Wortsuche',
	dailyPuzzle: 'Leichtes Tägliches Rätsel',
	easyPuzzle: 'Einfache Rätsel',
	enterTheCodeHere: 'Hier den Code eingeben:',
	redeemPromoCode: 'Promo Code einlösen',
	redeem: 'Einlösen',
	promoCodeValidation: 'Bitte geben Sie einen gültigen Code ein!',
	starterPackage: 'STARTERPAKET!',
	bestSellingOffer: 'MEIST GEKAUFTES ANGEBOT!',
	saveFoxOffer: 'SPAR FUCHS ANGEBOT!',
	joker: 'Joker',
	freeHints: 'GRATIS JOKER',
	allThreeHoursHints: 'Alle 3 Stunden gratis Joker!',
	collect: 'Einsammeln',
	yes: 'Ja',
	deleteAccountTitle: 'Sind Sie sicher, dass Sie Ihr Konto löschen möchten?',
	continueWithApple: 'Weiter mit Apple',
	timeSoFar: 'Bisherige Zeit',
	jokerAvailable: 'Joker verfügbar',
	jokerDescription: 'Nutzen Sie jederzeit Joker, um knifflige Stellen zu meistern und Zeit zu gewinnen',
	backToLobby: 'Zur Lobby',
	start: 'Start',
	intermediatePuzzles: 'Fortgeschrittene Rätsel',
	hardPuzzles: 'Schwere Rätsel',
	proPuzzles: 'Profi Rätsel',
	fullPage: 'Vollformat',
	doublePage: 'Doppelseiter',
	picturePuzzle: 'Bilderrätsel',
	showMoreLevels: 'Mehr anzeigen',
	showLessLevels: 'Weniger Ebenen anzeigen',
	doYouLikeRateFuchs: 'Gefällt dir der Rate-fuchs?',
	rateNow: 'Jetzt bewerten...',
	thankYouForYourFeedback: 'Vielen Dank für Ihr Feedback',
	gameOver: 'Spiel beendet',
	youMadeMistakesAndEndedTheGame: 'Du hast 3 Fehler gemacht und das Spiel beendet',
	secondChance: 'Zweite Chance',
	restart: 'Neustart',
	timeRequired: 'Zeitbedarf',
	mistake: 'Fehler',
	solved: 'Gelöst',
	done: 'Geschafft!',
	thePuzzle: 'Das Rätsel',
	isComplete: 'ist vollständig!',
	help: 'Hilfe',
	currentBalance: 'Aktuelles Guthaben',
	sound: 'Klang',
	logout: 'Abmelden',
	feedback: 'Feedback',
	language: 'Sprache',
	smallCrosswordChest: 'Kleine Kreuzwort-Truhe',
	mediumCrosswordChest: 'Mittlere Kreuzwort-Truhe',
	bigCrosswordChest: 'Große Kreuzwort-Truhe',
	hugeCrosswordChest: 'Riesige Kreuzwort-Truhe',
	smallCrosswordDescription: 'Beinhaltet für Kreuzwort-Truhe 8 Lösungs-Buchstaben',
	mediumCrosswordDescription: 'Beinhaltet für Kreuzwort-Truhe 16 Lösungs-Buchstaben',
	bigCrosswordDescription: 'Beinhaltet für Kreuzwort-Truhe 32 Lösungs-Buchstaben',
	hugeCrosswordDescription: 'Beinhaltet für Kreuzwort-Truhe 48 Lösungs-Buchstaben',
	smallGridPuzzleChest: 'Kleine Gitterrätsel-Truhe',
	mediumGridPuzzleChest: 'Mittlere Gitterrätsel-Truhe',
	bigGridPuzzleChest: 'Große Gitterrätsel-Truhe',
	smallGridPuzzleDescription: 'Beinhaltet für Gitterrätsel-Truhe 6 Lösungs-Buchstaben',
	mediumGridPuzzleDescription: 'Beinhaltet für Gitterrätsel-Truhe 10 Lösungs-Buchstaben',
	bigGridPuzzleDescription: 'Beinhaltet für Gitterrätsel-Truhe 18 Lösungs-Buchstaben',
	smallSudokuChest: 'Kleine Sudoku-Truhe',
	mediumSudokuChest: 'Mittlere Sudoku-Truhe',
	bigSudokuChest: 'Große Sudoku-Truhe',
	smallSudokuDescription: 'Beinhaltet für Sudoku-Truhe 4 Lösungs-Buchstaben',
	mediumSudokuDescription: 'Beinhaltet für Sudoku-Truhe 8 Lösungs-Buchstaben',
	bigSudokuDescription: 'Beinhaltet für 12 Sudoku-Truhe Lösungs-Buchstaben',
	smallWordSearchChest: 'Kleine Wortsuche-Truhe',
	mediumWordSearchChest: 'Mittlere Wortsuche-Truhe',
	bigWordSearchChest: 'Große Wortsuche-Truhe',
	smallWordSearchDescription: 'Beinhaltet für Wortsuche-Truhe 4 Lösungs-Buchstaben',
	mediumWordSearchDescription: 'Beinhaltet für Wortsuche-Truhe 8 Lösungs-Buchstaben',
	bigWordSearchDescription: 'Beinhaltet für Wortsuche-Truhe 14 Lösungs-Buchstaben',
	note: 'Hinweis',
	chestDescription:
		'Öffne in einem beliebigen Rätsel eine Wortschatz-Truhe und erhalte automatisch Joker-Buchstaben, so kannst du Rätsel noch einfacher und schneller lösen',
	showMore: 'Mehr anzeigen',
	showLess: 'Weniger anzeigen',
	chooseYourAvatar: 'Wähle Deinen Avatar',
	userValidation: 'Name ist erforderlich!',
	feedbackFormValidation: 'Nachricht ist erforderlich!',
	whatCanWeImprove: 'Was können wir verbessern?',
	youOpinionIsImportantToUs: 'Deine Meinung ist uns wichtig:',
	gameIsUpdated: 'Das Spiel wurde aktualisiert',
	gameLobbyDescription:
		'Lesen Sie die Hinweise und tragen Sie die entsprechenden Wörter in das Raster ein, indem Sie auf ein Quadrat klicken. Wörter kreuzen sich horizontal und vertikal. Lösen Sie das Rätsel, indem Sie die restlichen Wörter identifizieren und eintragen',
	swipeLeftOrRightToSelectCrosswordOrSudokuPuzzle:
		'Wischen Sie nach links oder rechts, um ein Kreuzworträtsel oder ein Sudoku-Rätsel auszuwählen.',
	hintButtonDescription:
		'Tippen Sie auf diese Schaltfläche, um den Hinweis-Shop zu öffnen. Hier können Sie sich mit neuen Hinweisen eindecken, die Ihnen bei Rätseln helfen.',
	helpSettingDescription:
		'Durch Tippen auf dieses Symbol öffnen Sie die Einstellungen. Hier können Sie Töne ein- oder ausschalten, sich registrieren und zusätzliche Informationen anzeigen.',
	unlockNow: 'Jetzt freischalten?',
	purchaseCost: 'Der Kauf kostet 10 Joker',
	cancel: 'Abbrechen',
	okay: 'Okay',
	requiredPurchasePuzzle: 'Zum Kauf werden 10 Joker benötigt',
	goToShop: 'Zum Shop',
	new: 'Neu',
	size: 'Groẞe',
	totalWords: 'Wörter gesamt',
	wordsCorrect: 'Wörter korrekt',
	dataProtection: 'Datenschutz',
	imprint: 'Impressum',
	justForFun: 'Just4Fun GmbH',
	allRightReserved: 'All Rights Reserved.',
	loginTitle: 'Anmelden',
	youAreNotRegisterSoPleaseRegisterFirst: 'Sie sind noch nicht registriert, also registrieren Sie sich bitte zuerst',
	invalidLoginCredentials: 'Ungültige Anmeldedaten',
	passwordDescription:
		'Passwörter müssen aus mind estens 8 Zeichen bestehen und sowohl Buchstaben als auch Zeichen enthalten!',
	rememberMe: 'Angemeldet bleiben',
	youAreAlreadyRegister: 'Sie sind bereits registriert',
	registerViaEMail: 'Registrieren Sie sich per E-Mail',
	sendTheEmailSuccessfully: 'E-Mail versendet',
	userIsNotExists: 'Der Benutzer ist nicht vorhanden',
	reload: 'Neu laden',
	partnerShip: 'Partnerschaften',
	save: 'Speichern',
	usernameUpdatedSuccessfully: 'Benutzername aktualisiert',
	agb: 'AGB',
	feedbackIsSendedSuccessfully: 'Feedback erfolgreich übermittelt',
	userAvatarIsUpdatedSuccessfully: 'Der Benutzeravatar wurde erfolgreich aktualisiert',
	jokersAreSuccessfullySended: 'Joker wurden erfolgreich gesendet',
	successfullyPurchase: 'Kauf erfolgreich'
};

export default de;
